import React, { useState, useEffect } from "react";
import {
  MultiSelectCombo,
  MultiSelectComboBoxOption,
} from "@/ui-controls/MultiSelectCombo";
import { getAuditUsers, getAuditTables, IAuditFilter } from "@/api/audits";

interface Props {
  onChangeFilters: (filter: IAuditFilter) => any;
}

const AuditFilters = (props: Props) => {
  const [auditUsers, setAuditUsers] = useState<MultiSelectComboBoxOption[]>([]);
  const [auditTables, setAuditTables] = useState<MultiSelectComboBoxOption[]>(
    []
  );
  const [filters, setFilters] = useState<IAuditFilter>({
    UserIds: [],
    EntityNames: [],
  });

  useEffect(() => {
    loadAuditUsers();
    loadAuditTables();
  }, []);

  useEffect(() => {
    props.onChangeFilters(filters);
  }, [filters]);

  const loadAuditUsers = () => {
    getAuditUsers().then(
      (result) => {
        let options = result.map(({ Id, EmailAddress }) => ({
          key: Id,
          text: EmailAddress,
        }));
        setAuditUsers(options);
      },
      (error) => {
        handleError(error);
      }
    );
  };

  const loadAuditTables = () => {
    getAuditTables().then(
      (result) => {
        let options = result.map(({ EntityName }) => ({
          key: EntityName,
          text: EntityName,
        }));
        setAuditTables(options);
      },
      (error) => {
        handleError(error);
      }
    );
  };

  const handleError = (error: Error) => {
    // Error handling would go here in real app
  };

  return (
    <>
      <div className="flex-container">
        <MultiSelectCombo
          options={auditUsers}
          label="Users"
          onChange={(items) => {
            const userIds = items.map((id) =>
              typeof id === "string" ? parseInt(id) : id
            );
            setFilters({ ...filters, UserIds: userIds });
          }}
        />

        <MultiSelectCombo
          options={auditTables}
          label="Tables"
          onChange={(items) => {
            setFilters({ ...filters, EntityNames: items });
          }}
        />
      </div>
    </>
  );
};

export default AuditFilters;
